import { useContext } from 'react';
import { FormGeneratorContext } from '../FormGenerator';

const useGetFormGeneratorItemError = (id, validation) => {
  const { invalidAnswers, unfulfilledRequiredItems, isValidated, validators } =
    useContext(FormGeneratorContext);

  const isInvalidValue = isValidated && !!invalidAnswers.find(a => a.id === id);
  const required = isValidated && !!unfulfilledRequiredItems.find(a => a.id === id);

  return {
    error: isInvalidValue && validators[validation]?.message,
    requiredError: required,
  };
};

export default useGetFormGeneratorItemError;
